export type SubscriptionStatusChipColor = 'success' | 'warning' | 'error' | 'info';

const ACTIVE_STATUSES = new Set(['ACTIVE']);
const WARNING_STATUSES = new Set(['TRIALING', 'PAST_DUE', 'GRACE_PERIOD']);
const EXPIRED_STATUSES = new Set([
  'EXPIRED',
  'CANCELED',
  'TRIALING_EXPIRED',
  'CANCELED_AFTER_TRIAL',
  'CANCELED_SUBSCRIPTION',
]);

/**
 * Maps a raw `subscriptionStatus` string onto the project-wide HACCP color
 * legend (green = compliant/active, yellow = trial or warning, red = expired
 * / non-compliant, blue = informative fallback for anything unrecognized).
 */
export function getSubscriptionStatusChipColor(
  subscriptionStatus: string,
): SubscriptionStatusChipColor {
  if (ACTIVE_STATUSES.has(subscriptionStatus)) {
    return 'success';
  }
  if (WARNING_STATUSES.has(subscriptionStatus)) {
    return 'warning';
  }
  if (EXPIRED_STATUSES.has(subscriptionStatus)) {
    return 'error';
  }
  return 'info';
}
